import { getGeolocation, getCookiesConsent } from '../../utils'

const userState = {
  id: 0,
  geolocation: getGeolocation(),
  cookies: getCookiesConsent(),
}

export default userState
